export const facebookPageUrl = 'https://facebook.com/fit.hier';
export const instagramPageUrl = 'https://instagram.com/fit.hier';
export const threadsPageUrl = 'https://www.threads.net/@fysio.hier';
